Ext.define('SA.ListenerFactory', {
    singleton: true,

    create(eventSource, eventName, callback = null) {
        var listener = new SA.Listener({eventSource, eventName});

        if (callback !== null) {
            listener.setCallback(callback);
            listener.listen();
        }

        return listener;
    }
});